module.exports = __webpack_public_path__ + "static/mopz-extraimg1@2x-min-dcaa7ff2bda446e669579ab94a627142.png";